import styled from "styled-components"

export default styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: center;
	width: 100%;
`